import { BaseApiService } from "../base/base-api.service";
import { DocumentSTO } from "../../models/documents";
import { PageByDocType } from "../../models/employee-document-requests/document-request-filter";
import { LegalEntityRegDocsDTO } from "../../models/legal-entity-reg-docs/legal-entity-reg-docs-dto";
import { LegalEntityRegDocsFilter } from "../../models/legal-entity-reg-docs/legal-entity-reg-docs-filter";
import { Page } from "../../models/api/page";
import { SearchOptions } from "../../models/search-options/search-options";

// Used only to load company docs
export class LegalEntityRegDocsApiService extends BaseApiService<LegalEntityRegDocsDTO, DocumentSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityRegDocs",
      loadItemsPath: "/GetLegalEntityRegDocs",
      saveItemsPath: "",
    });
  }
}

export const loadLegalEntityRegDocs = async (
  legalEntityIds: string[],
  searchOptions: SearchOptions,
  page: Page,
  pagingByDocType: PageByDocType[],
  signal?: AbortSignal
) => {
  const response = await new LegalEntityRegDocsApiService().loadItems(
    {
      legalEntityIds,
      pagingByDocType,
    } as LegalEntityRegDocsFilter,
    searchOptions.query,
    undefined,
    page,
    searchOptions.exactMatch,
    undefined,
    signal
  );

  return response;
};
